// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ESlateCoverageKind } from "@sequentech/ui-core";
export var ESlateCoverageLabel;
(function (ESlateCoverageLabel) {
    ESlateCoverageLabel["FULL"] = "full";
    ESlateCoverageLabel["SINGLE_CONTEST"] = "single-contest";
    ESlateCoverageLabel["PARTIAL"] = "partial";
})(ESlateCoverageLabel || (ESlateCoverageLabel = {}));
export var ESlateOfficesLayout;
(function (ESlateOfficesLayout) {
    ESlateOfficesLayout["ALIGNED"] = "aligned";
    ESlateOfficesLayout["STACKED"] = "stacked";
})(ESlateOfficesLayout || (ESlateOfficesLayout = {}));
var findContest = function (contests, contestId) {
    return contests.find(function (contest) { return contest.id === contestId; });
};
export var getSlateCoverageLabel = function (coverage, contests) {
    if (coverage.kind === ESlateCoverageKind.COMPLETE) {
        return { label: ESlateCoverageLabel.FULL };
    }
    var onlyContest = coverage.covered.length === 1 && coverage.uncovered_contest_ids.length > 0
        ? findContest(contests, coverage.covered[0].contest_id)
        : undefined;
    if (onlyContest) {
        return { label: ESlateCoverageLabel.SINGLE_CONTEST, contest: onlyContest };
    }
    return { label: ESlateCoverageLabel.PARTIAL };
};
export var getCoveredContests = function (coverage, contests) {
    return coverage.covered.flatMap(function (covered) { var _a; return (_a = findContest(contests, covered.contest_id)) !== null && _a !== void 0 ? _a : []; });
};
export var getUncoveredContests = function (coverage, contests) {
    return coverage.uncovered_contest_ids.flatMap(function (contestId) { var _a; return (_a = findContest(contests, contestId)) !== null && _a !== void 0 ? _a : []; });
};
/**
 * The offices of a slate card, in ballot order. The aligned layout lists every
 * contest the voter can vote in, with no candidates where the slate has none, so
 * that the same office sits at the same level on every card. The stacked layout
 * lists only the contests the slate has candidates in.
 */
export var getSlateOffices = function (coverage, contests, layout) {
    return contests.flatMap(function (contest) {
        var covered = coverage.covered.find(function (entry) { return entry.contest_id === contest.id; });
        if (covered) {
            var candidates = covered.candidate_ids.flatMap(function (candidateId) { var _a; return (_a = contest.candidates.find(function (candidate) { return candidate.id === candidateId; })) !== null && _a !== void 0 ? _a : []; });
            return [{ contest: contest, candidates: candidates }];
        }
        var isUncovered = coverage.uncovered_contest_ids.includes(contest.id);
        return isUncovered && layout === ESlateOfficesLayout.ALIGNED
            ? [{ contest: contest, candidates: [] }]
            : [];
    });
};
export var isContestCoveredBySlate = function (coverage, contestId) {
    return coverage.covered.some(function (covered) { return covered.contest_id === contestId; });
};
